






















































































import { AxiosError } from 'axios';
import Vue from 'vue';
import Component from 'vue-class-component';

import SparkLogo from '@/components/SparkLogo.vue';
import { analyticsTrack } from '@/utils/usageAnalytics';

@Component({
  components: {
    SparkLogo,
  },
})
export default class LoginPage extends Vue {
  form: any;
  state: {
    isLoading: boolean;
  };

  constructor() {
    super();
    this.state = {
      isLoading: false,
    };
  }

  beforeCreate() {
    this.form = this.$form.createForm(this);
  }

  validateEmail(rule: any, value: string, callback: any) {
    const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
    if (regex.test(value)) {
      callback();
    }
    callback();
  }

  handleSubmit(e: Event) {
    e.preventDefault();
    analyticsTrack('LOGIN_SIGNIN_BTN_CLICKED');
    const {
      form: { validateFields },
      state,
    } = this;

    state.isLoading = true;

    const validateFieldsKey = ['email', 'password'];

    validateFields(
      validateFieldsKey,
      { force: true },
      async (
        err: { errors: any[] } | null,
        values: { email: string; password: string }
      ) => {
        if (!err) {
          const loginParams = {
            ...values,
          };
          try {
            await this.$store.dispatch('auth/loginWithPass', loginParams);
            this.loginSuccess();
          } catch (err) {
            this.requestFailed(err);
          }
          state.isLoading = false;
        } else {
          setTimeout(() => {
            state.isLoading = false;
          }, 600);
        }
      }
    );
  }

  loginSuccess() {
    const to = (this.$route.query.to as string) || 'start';
    this.$message.success({
      content: 'Login Successful',
      duration: 1,
    });
    setTimeout(() => {
      this.$router.push({ name: to });
    }, 2000);
  }
  requestFailed(err: AxiosError) {
    analyticsTrack('LOGIN_SIGNIN_FAILURE', {
      error: err,
    });
    this.$notification.error({
      message: 'User login failed.',
      description:
        ((err.response || {}).data || {}).message || 'Please try again later.',
      duration: 2,
    });
  }
}
